export function isCaptchaValid(key = "captcha_verified_at") {
  const lastVerified = localStorage.getItem(key);
  if (!lastVerified) return false;
  const last = new Date(parseInt(lastVerified, 10));
  const now = new Date();
  const diffDays = (now - last) / (1000 * 60 * 60 * 24);
  return diffDays < 7;
}

export function setCaptchaVerified(key = "captcha_verified_at") {
  localStorage.setItem(key, Date.now().toString());
}
